import React from 'react';

interface Props {
  total: number;
  page: number;
  pageSize?: number;
  onChange: (page: number) => void;
  showTotal?: boolean;
}

export default function Pagination({ total, page, pageSize = 20, onChange, showTotal = true }: Props) {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;

  const pages: (number | '...')[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push('...');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) pages.push('...');
    pages.push(totalPages);
  }

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t bg-white">
      {showTotal && (
        <p className="text-xs text-gray-500">
          Showing <span className="font-semibold text-gray-700">{start}–{end}</span> of <span className="font-semibold text-gray-700">{total}</span> records
        </p>
      )}
      <div className="flex items-center gap-1">
        <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (page > 1) onChange(page - 1); }} disabled={page === 1}
          className="px-3 py-1.5 rounded-lg text-sm border hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
          ← Prev
        </button>
        {pages.map((p, i) =>
          p === '...' ? (
            <span key={`d${i}`} className="px-2 text-gray-400 text-sm">…</span>
          ) : (
            <button type="button" key={p} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange(p as number); }}
              className={`w-8 h-8 rounded-lg text-sm font-medium transition-all ${
                page === p ? 'text-white' : 'border hover:bg-gray-50 text-gray-700'
              }`}
              style={page === p ? { background: '#02357A' } : {}}>
              {p}
            </button>
          )
        )}
        <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (page < totalPages) onChange(page + 1); }} disabled={page === totalPages}
          className="px-3 py-1.5 rounded-lg text-sm border hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
          Next →
        </button>
      </div>
    </div>
  );
}
